import { createPropStyling } from '../privatePropStylingUtils';
export const backgroundCssAttrNames = ['background', 'backgroundColor', 'backgroundImage', 'backgroundPosition', 'backgroundRepeat', 'backgroundSize'];
export const backgroundPropStyling = createPropStyling(backgroundCssAttrNames);
//# sourceMappingURL=backgroundPropStyling.js.map